"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasPublicRegistrationWorkflow = void 0;
const Types_1 = require("./Types");
const CanvasWorkflow_1 = require("./CanvasWorkflow");
const validation_1 = require("./validation/validation");
class CanvasPublicRegistrationWorkflow extends CanvasWorkflow_1.CanvasWorkflow {
    constructor() {
        super();
        this.inputPin = [Types_1.InputPin.INPUT];
        this.outputPin = [Types_1.OutputPin.OUTPUT, Types_1.OutputPin.DECLINE_OUTPUT];
        this.type = Types_1.WorkflowType.PUBLIC_REGISTRATION;
        this.settings = this.getDefaultSettings();
        this.customProcess = {
            after_public_registration_actions: null,
        };
        this.schema = validation_1.PublicRegistrationSchema;
    }
    getDefaultSettings() {
        return {
            form_ids: [],
            page_ids: [],
            thank_you_page_id: null,
            cancellation_workflow_id: null,
            email_campaign_id: null,
            decline_workflow_id: null,
            registration_completed_stage_name: '',
            registration_pending_stage_name: '',
            next_workflow_ids: {
                next_workflow: null,
            },
        };
    }
    setNextWorkflow(pin, next_workflow_id) {
        if (pin === Types_1.OutputPin.DECLINE_OUTPUT) {
            this.settings.decline_workflow_id = next_workflow_id;
        }
        this.setDefaultNextWorkflow(pin, next_workflow_id);
    }
    getNextWorkflows() {
        const o = {};
        o[Types_1.OutputPin.DECLINE_OUTPUT] = this.settings.decline_workflow_id;
        o[Types_1.OutputPin.OUTPUT] = this.getDefaultNextWorkflow();
        return o;
    }
    setCustomProcess(s, p) {
        if (s === 'after_public_registration_actions') {
            this.customProcess.after_public_registration_actions = p;
        }
    }
    getProperties() {
        return [
            {
                attribute: 'registration_pending_stage_name',
                datasource: null,
                label: 'REGISTRATION_PENDING_STAGE_NAME',
                type: 'text',
                mandatory: true,
                value: this.settings.registration_pending_stage_name,
            },
            {
                attribute: 'form_ids',
                datasource: 'Form',
                label: 'FORMS',
                type: 'multiselect',
                mandatory: true,
                value: this.settings.form_ids,
            },
            {
                attribute: 'thank_you_page_id',
                datasource: 'Page',
                label: 'THANK_YOU_PAGE',
                type: 'select',
                mandatory: true,
                value: this.settings.thank_you_page_id,
            },
            {
                attribute: 'email_campaign_id',
                datasource: 'Email',
                label: 'THANK_YOU_EMAIL',
                type: 'select',
                mandatory: true,
                value: this.settings.email_campaign_id,
            },
            {
                attribute: 'after_public_registration_actions',
                datasource: null,
                label: 'AFTER_REGISTRATION_ACTIONS',
                type: 'process',
                mandatory: false,
                value: null,
            },
            {
                attribute: 'page_ids',
                datasource: 'Page',
                label: 'ADDITIONAL_PAGES',
                type: 'multiselect',
                mandatory: false,
                value: this.settings.page_ids,
            },
        ];
    }
}
exports.CanvasPublicRegistrationWorkflow = CanvasPublicRegistrationWorkflow;
